var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo_book_image"},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_c('b-img-lazy',_vm._b({attrs:{"src":_vm.retrievePhotoBookImage(),"alt":""}},'b-img-lazy',_vm.mainProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }